import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Genre } from '../../../types/types';
interface PropTypes {
  data: Genre;
}
const GenreItem: React.FC<PropTypes> = t0 => {
  const $ = _c(2);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.name) {
    t1 = <div className="h-[25px] items-center justify-center bg-black px-4 rounded-md transition-all-[250ms] hover:opacity-[0.4]"><span className="text-sm font-bold text-white">{data.name}</span></div>;
    $[0] = data.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default GenreItem;